export const getFormatTime = (time, format) => {
  // console.log(time,'date')
  if (!time) {
    return ''
  }
  let date = new Date(time)
  let year = date.getFullYear()
  let month = (date.getMonth() + 1 + '').padStart(2, '0')
  let day = (date.getDate() + '').padStart(2, '0')
  let hour = (date.getHours() + '').padStart(2, '0')
  let minute = (date.getMinutes() + '').padStart(2, '0')
  let second = (date.getSeconds() + '').padStart(2, '0')
  if (format == 'yyyy-mm') {
    return `${year}-${month}`
  } else if (format == 'yyyy-mm-dd') {
    return `${year}-${month}-${day}`
  } else if (format == 'yyyy-mm-dd HH:mm:ss') {
    return `${year}-${month}-${day} ${hour}:${minute}:${second}`
  }
  //以此类推，是哪种格式就把哪种格式写上去
}
// 处理账户状态的方法
export const handleAccountStatus = (val) => {
  switch (val) {
    case '0':
      return '正常'
    case '1':
      return '删除'
    case '2':
      return '挂失'
    case '3':
      return '锁定 '
    case '4':
      return '销户'
    case '5':
      return '不动户'
    case '6':
      return '睡眠户'
    case '7':
      return '止付'
    case '8':
      return '证件过期'
    default:
      return '---'
  }
}
// 处理客户类型细分的方法
export const handleCustTypeSub = (val) => {
  switch (val) {
    case '0101':
      return '法人企业'
    case '0102':
      return '非法人企业'
    case '0103':
      return '经营性个人客户'
    case '0104':
      return '锁事业单位'
    case '0105':
      return '社会团体'
    case '0106':
      return '党政机关'
    case '0107':
      return '金融机构'
    case '0199':
      return '其他'
    case '0201':
      return '单一集团客户'
    case '0202':
      return '综合集团客户'
    case '0203':
      return '准集团客户'
    case '0204':
      return '联保体客户'
    case '03':
      return '消费类个人客户'
    case '04':
      return '个体工商户'
    case '05':
      return '同业客户'
    case '06':
      return '专业市场客户'
    case '07':
      return '产/行业集群'
    case '08':
      return '网格化商圈'
    default:
      return '-----'
  }
}
// 处理渠道方法
export const handleChannelNo = (arr, channelNum, type) => {
  if (arr.length === 0) {
    return '---'
  }
  for (let i = 0; i < arr.length; i++){
    if (type === '1') {
      
      // 渠道
      if (arr[i].channelNo === channelNum) {
        return arr[i].channelName
      }
    } else if (type === '2') {
      //应用
      if (arr[i].appNo === channelNum) {
        return arr[i].channelName
      }
    }
  }
}

/**
 * 求迪卡尔积
 * @param arr
 * @returns {*|(function(*, *): *[])}
 */
export const cartesian = (arr) => {
  return [].reduce.call(arr, function (col, set) {
    let res = [];
    col.forEach(c => {
      set.forEach(s => {
        let t = [].concat(Array.isArray(c) ? c : [c]);
        t.push(s);
        res.push(t);
      })
    });
    return res;
  });
}

/**
 * 将数组根据字段进行合并计算
 *  如以下数据list=[{"姓名":"张三","年龄":18,"性别":"男"},{"姓名":"李四","年龄":19,"性别":"女"},{"姓名":"王五","年龄":19,"性别":"男"}]
 *  如计算不同性别人的年龄之和、人数：groupBy(list, ["性别"],{count:["姓名"],sum:["年龄"] }
 *  返回：  [{"性别":"男","合计#年龄":37,"计数#姓名":2},{"性别":"女","合计#年龄":19,"计数#姓名":1}]
 * @param list 数组,
 * @param groupFields 分组字段
 * @param aggrFields 汇聚字段
 * @param compact 是否删除不存在值的分组记录
 * @returns {*[]}
 */
export const groupBy = (list, groupFields, aggrFields, compact=false) =>{
  let sumFields = aggrFields['sum']||[]
  let countFields = aggrFields['count']||[]
  let maxFields = aggrFields['max']||[]
  let minFields = aggrFields['min']||[]
  let calculated = list.reduce((acc, cur)=>{
    // 为方便计算，把多个分组字段合并成一个字段
    let key = groupFields.map(field=>cur[field]).join("#")
    let accVal = acc[key]??{}
    sumFields.forEach(field=>{
      accVal["合计#"+field] = (cur[field]??0) + (accVal["合计#"+field]??0)
    })
    countFields.forEach(field=>{
      accVal["计数#"+field] = 1 + (accVal["计数#"+field]??0)
    })
    maxFields.forEach(field=>{
      accVal["最大值#"+field] = Math.max(cur[field]??Number.MIN_VALUE , accVal["最大值#"+field]??Number.MIN_VALUE)
    })
    minFields.forEach(field=>{
      accVal["最小值#"+field] = Math.min(cur[field]??Number.MAX_VALUE , accVal["最小值#"+field]??Number.MAX_VALUE)
    })
    acc[key] = accVal
    return acc
  }, {})
  let result = []
  let keys = []
  if(compact){
    keys = Object.keys(calculated)
  }else{
    keys = cartesian(groupFields.map(field=>Array.from(new Set(list.map(item=>item[field])))))
    .map(arr=>arr.join("#"))
  }
  for(let o in keys){
    let obj = {}
    let groupValues = keys[o].split("#")
    for(let j=0, l=groupFields.length; j<l; j++){
      obj[groupFields[j]] = groupValues[j]
    }
    result.push(Object.assign(obj, calculated[keys[o]]))
  }
  return result
}

export const generateRandomString = (length)=>{
  const characters='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
  let result = ''
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random()*characters.length)
    result += characters.charAt(randomIndex)
  }
  return result
}

/**
 * 并发池：限制同时执行的异步任务数量
 * @param {number} concurrency 最大并发数
 * @param {Array} items 待处理的数据项
 * @param {Function} fn 处理函数，接收 (item, index) 参数，返回 Promise
 * @returns {Promise<Array>} 所有任务的结果数组
 *
 * @example
 * const results = await asyncPool(3, urls, url => fetch(url))
 */
export async function asyncPool(concurrency, items, fn) {
  const results = [];       // 收集所有 Promise
  const executing = new Set(); // 正在执行的 Promise

  for (const [index, item] of items.entries()) {
    // 创建任务 Promise
    const p = Promise.resolve().then(() => fn(item, index));
    results.push(p);

    // 当并发数小于总数时，需要限流
    if (concurrency <= items.length) {
      // 无论成功或失败，完成后从执行集合中移除（防止 reject 导致 executing 泄漏）
      const e = p.then(
        () => executing.delete(e),
        () => executing.delete(e)
      );
      executing.add(e);
      // 达到最大并发数时等待任意一个完成
      if (executing.size >= concurrency) {
        await Promise.race(executing);
      }
    }
  }

  // 等待所有任务完成（所有异常已在回调内捕获，Promise.all 即可，避免 ES2020 依赖）
  return Promise.all(results);
}

/**
 * 带指数退避的自动重试
 * @param {Function} fn 需要执行的异步函数，返回 Promise
 * @param {number} [maxRetries=2] 最大重试次数
 * @param {number} [baseDelay=1000] 基础延迟（毫秒），每次重试翻倍
 * @returns {Promise<*>} fn 的返回值
 *
 * @example
 * const data = await retryAsync(() => fetch(url), 3, 500)
 */
export async function retryAsync(fn, maxRetries = 2, baseDelay = 1000) {
  let lastError;
  for (let attempt = 0; attempt <= maxRetries; attempt++) {
    try {
      return await fn();
    } catch (error) {
      lastError = error;
      if (attempt < maxRetries) {
        // 指数退避：baseDelay * 2^attempt + 随机抖动 0~500ms
        const delay = baseDelay * Math.pow(2, attempt) + Math.random() * 500;
        console.warn(`重试第 ${attempt + 1}/${maxRetries} 次，等待 ${Math.round(delay)}ms 后重试:`, error.message);
        await new Promise(resolve => setTimeout(resolve, delay));
      }
    }
  }
  throw lastError;
}